import { css } from 'aphrodite';
import * as React from 'react';
import { EyeIcon } from '../svgs/icons/EyeIcon';
import { EyeSlashIcon } from '../svgs/icons/EyeSlashIcon';
import { ITextInputProps, TextInput } from '../TextInput';
import { styleSheet } from './styles';

export interface IPasswordInputProps extends Omit<ITextInputProps, 'type' | 'rightAccessory'> {
	showToggleButton?: boolean;
}

export const PasswordInput: React.FC<IPasswordInputProps> = props => {
	const { showToggleButton = true, ...restProps } = props;
	const [isVisible, setIsVisible] = React.useState(false);

	const toggleVisibility = React.useCallback(() => {
		setIsVisible(prev => !prev);
	}, []);

	const rightAccessory = showToggleButton ? (
		<button
			type='button'
			className={css(styleSheet.toggleButton)}
			onClick={toggleVisibility}
			tabIndex={-1}
			aria-label={isVisible ? 'Hide password' : 'Show password'}
		>
			{isVisible ? <EyeIcon /> : <EyeSlashIcon />}
		</button>
	) : undefined;

	return <TextInput {...restProps} type={isVisible ? 'text' : 'password'} rightAccessory={rightAccessory} />;
};
